import { POST, GET, PUT, DELETE } from '../request'

export const crearEvento = evento =>
  POST('/api/core/interno/eventos-calendario', evento)

export const getEventos = ({ mes }) =>
  GET('/api/core/interno/eventos-calendario/list', { mes })

export const actualizarEvento = evento =>
  PUT('/api/core/interno/eventos-calendario', evento)

export const borrarEvento = id =>
  DELETE('/api/core/interno/eventos-calendario', { id })
